module.exports = {
  "home.description": `Storie di Tecnologia in SMC. Il blog aziendale di SMC dove raccontiamo il nostro approccio al design, alle tecnologie e allo sviluppo.`,
  "locale.it": `Italiano`,
  "locale.en": `Inglese`,
  "not-found": "Non Trovato",
  "not-found-expl": "La pagina che cerchi non esiste.",
  "go-back-home": "Torna alla home",
  "back-to-smc-it": "SITO CORPORATE >",
  "this-article-is-available-also-in-alternates": `Questo articolo è disponibile anche in {alternates}`,
  "time-to-read-in-minutes": `
    {minutes, plural,
      one {un minuto}
      other {{minutes} minuti}
    } di lettura
  `,
  "related-articles": "Potrebbero interessarti anche…",
  "notify-me-when-time-is-up": `Avvisami quando è scaduto il tempo`,
  prediction: `Predizione`,
  "prediction-will-be-verified-at": `Scade {at}`,
  hero1: "Partner per competere",
  hero2: "Storie di tecnologia in SMC",
  categoryTitle: "{category} in SMC",
  writtenBy: "scritto da",
  learnMore: "Scopri di più",
};
